import { ChainId } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
const fetchTrendingTokens = async (networkFilter, resolution, limit) => {
  const adjustedRes = () => {
    switch (resolution) {
      case '24':
        return '1D';
      case '12':
        return '720';
      case '4':
        return '240';
      case '1':
        return '60';
      default:
        return '1D';
    }
  };
  const networks = networkFilter.join(',');
  const url = `/api/explore/trendingToken?limit=${limit}&networkFilter=${networks}&resolution=${adjustedRes()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const payload = await response.json();
  const data = payload === null || payload === void 0 ? void 0 : payload.data;
  const formatted = data.data.listTopTokens.map(x => {
    return Object.assign(Object.assign({}, x), {
      priceUSD: x.price,
      change24: x.priceChange24,
      change1: x.priceChange1,
      change4: x.priceChange4,
      change12: x.priceChange12,
      logo: x.imageSmallUrl,
      marketCap: x.marketCap,
      token: Object.assign(Object.assign({}, x), {
        priceUSD: x.price,
        change24: x.priceChange24,
        change1: x.priceChange1,
        change4: x.priceChange4,
        change12: x.priceChange12,
        logo: x.imageSmallUrl
      })
    });
  });
  formatted.sort((token1, token2) => parseFloat(token2 === null || token2 === void 0 ? void 0 : token2.marketCap) - parseFloat(token1 === null || token1 === void 0 ? void 0 : token1.marketCap)).sort((token1, _) => {
    if ((token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.SOLANA || (token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.SOLANA_DLN || (token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.BASE) {
      return -1;
    } else {
      return 1;
    }
  });
  // Put token with networkid 1 at end
  return formatted;
};
export default function useTrendingTokens({
  networkFilter,
  resolution = '24',
  limit = 100,
  enabled = true
}) {
  const {
    data: tokens,
    isLoading,
    error
  } = useQuery({
    queryKey: ['trendingTokens', networkFilter, resolution, limit],
    queryFn: () => fetchTrendingTokens(networkFilter, resolution, limit),
    staleTime: 1000 * 30,
    enabled
  });
  return {
    tokens,
    isLoading,
    error
  };
}